import { StorageService } from "@/services/storageService";
import { toastError } from "./toastify";

export const downloadFile = async (url: string, name?: string) => {
  try {
    const downloadUrl = await StorageService.getDownloadUrl(url, name);

    const anchor = document.createElement("a");
    anchor.href = downloadUrl;
    anchor.rel = "noopener";
    if (name) anchor.download = name;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
  } catch (error) {
    console.error("Download file failed:", error);
    toastError("ファイルのダウンロードに失敗しました");
  }
};
